/*
 * @Author: shen
 * @Date: 2021-07-18 12:42:46
 * @LastEditors: shen
 * @LastEditTime: 2021-07-25 23:20:46
 * @Description:
 */
import Watcher from './core/watcher';
import { isObject, isArray, merge, deepClone } from './helpers/util';

export default function createConnect(_states) {
  return function connect(options) {
    const app = getApp();
    const { onLoad, onUnload, attached, detached, lifetimes } = options;
    function mount(opt) {
      this.$app = app;
      this.$store = app.store;
      const states = _states || options.states || [];
      if (!isValidMap(states)) {
        console.error('[wx-store] mapState: mapper parameter must be either an Array or an Object');
      }
      const initMapStateToData = {};
      const mapStates = normalizeMap(states);
      app.store.globalKeys.forEach((key) => {
        mapStates.push({ key, val: key });
      });
      const watcher = new Watcher(this, mapStates);
      this.$store._deps.push(watcher);
      mapStates.forEach(({ key, val }) => {
        initMapStateToData[key] = app.store.state[val];
      });
      this.setData(Object.assign({}, this.data, initMapStateToData));
      onLoad && onLoad.call(this, opt);
      attached && attached.call(this, opt);
      lifetimes && lifetimes.attached && lifetimes.attached.call(this, opt);
    }

    function unmount() {
      this.$store._deps.pop();
      onUnload && onUnload.call(this);
      detached && detached.call(this);
      lifetimes && lifetimes.detached && lifetimes.detached.call(this);
    }

    options.onLoad = options.attached = mount;
    options.onUnload = options.detached = unmount;

    if (lifetimes) {
      options.lifetimes = {
        attached: mount,
        detached: unmount,
      };
    }
    return options;
  };
}

function normalizeMap(map) {
  if (!isValidMap(map)) {
    return [];
  }
  return isArray(map) ? map.map((key) => ({ key, val: key })) : Object.keys(map).map((key) => ({ key, val: map[key] }));
}

function isValidMap(map) {
  return isArray(map) || isObject(map);
}
